module.exports = __webpack_public_path__ + "static/media/song_zh.e062d029.png";